import React from 'react'
import {HubspotV2Tag, useTestTag} from 'Event/hubspot-v2'
import {HUBSPOTv2} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestHubspotV2TagButton(props: {
  tag: HubspotV2Tag | null
}) {
  const addTag = useTestTag()

  return (
    <TestTagButton tag={props.tag} integration={HUBSPOTv2} addTag={addTag} />
  )
}
